module.exports = __webpack_public_path__ + "static/media/house.0713be79.png";